import { render } from "./monitorStudents.vue?vue&type=template&id=8509a762&scoped=true"
import script from "./monitorStudents.vue?vue&type=script&lang=js"
export * from "./monitorStudents.vue?vue&type=script&lang=js"

import "./monitorStudents.vue?vue&type=style&index=0&id=8509a762&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8509a762"]])

export default __exports__